export class Question {
    question: string;
    red: string;
    yellow: string;
    blue: string;
    answer: string;
    details: string;
}
